module.exports = __webpack_public_path__ + "img/07.1f5367c2.jpg";